import {
    put,
    call,
    takeLatest,
} from 'redux-saga/effects';

import AuthUtil from '../../AuthUtil';
import { LOAN } from '../../../components/global/Server/endpoints';
import { hideError, showErrorMessage } from '../../actions/global';
import {
    LIST_CUSTOMER_LOAN,
    SAVE_CUSTOMER_LOAN,
} from '../../constants/loan';
import {storeCustomerLoan} from '../../actions/loan';
import {SERVER_FAILED_ERROR_MESSAGE} from "../../../components/dashboard/constants";


function* listCustomerLoanSaga(action) {
    try {
        const response = yield call(() => AuthUtil.postRequest(LOAN.LIST_CUSTOMER_LOAN,action.data))
         if (response.status === 200 && response.data.success) {
            yield put(storeCustomerLoan(response.data.loanHistory))
         }
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}


function* saveCustomerLoanSaga(action) {
    yield put(hideError())
    try {

        const response = yield call(() => AuthUtil.postRequest(LOAN.SAVE_CUSTOMER_LOAN, action.data))

        if (response.status === 200 && response.data.success) {
            if (action.callback && typeof action.callback === 'function') {
                action.callback(null, response.data.message);
            }
        } else {
            if (action.callback && typeof action.callback === 'function') {
                action.callback('error', response.data.message);
            }
            yield put(showErrorMessage(response.data.message))
        }


    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}


export default function* loanSagas() {
    yield takeLatest(LIST_CUSTOMER_LOAN, listCustomerLoanSaga)
    yield takeLatest(SAVE_CUSTOMER_LOAN, saveCustomerLoanSaga)
}

